import { Injectable } from '@angular/core';
import {
  ExtendedTextFilter,
  FilterField,
  JoinOperator,
  TaskFilter,
} from '@compumark/analyst-selection-tool-client';
import { FilterDateService } from 'src/app/results/services/filter-date.service';

@Injectable()
export class TaskFilterModelService {
  constructor(private filterDateService: FilterDateService) {}

  public createTaskFilter(filterModel: any): TaskFilter {
    return {
      normalizedTrademark: this.createExtendedTextFilter(filterModel.trademark),
      normalizedAnalyst: filterModel.analystName?.filter,
      orderId: filterModel.orderId?.filter,
      searchId: filterModel.searchId?.filter,
      orderType: filterModel.orderType?.values,
      taskStatus: this.createTaskStatusFilter(filterModel['taskStatus.label']),
      task: filterModel.taskDescription?.values,
      product: filterModel.productDescription?.values,
      normalizedBrand: filterModel.brand?.filter,
      deliveryDate: this.filterDateService.createDateFilter(
        filterModel.deliveryDate,
      ),
      normalizedFirm: filterModel.firm?.filter,
    };
  }

  private createTaskStatusFilter(taskStatusFilter: any): string[] | undefined {
    if (!taskStatusFilter?.values) {
      return undefined;
    }
    return taskStatusFilter?.values.map((tsf: string) => tsf.toUpperCase());
  }

  private createExtendedTextFilter(field: any): ExtendedTextFilter | undefined {
    if (field?.filter) {
      return {
        fields: field.filter.map((f: any) => {
          return {
            value: f,
            operator: undefined,
          } as FilterField;
        }),
        joinOperator: field.filterCondition || JoinOperator.AND,
      } as ExtendedTextFilter;
    }
    return undefined;
  }
}
